<template>
  <div class="tag-container">
    <el-tag
      v-for="filterFieldValue in shrinkedFilters"
      :key="`${filter.name}-${filterFieldValue.key}`"
      :closable="filterFieldValue.key !== 'expand'"
      size="small"
      class="filter-tag"
      :class="{ 'filter-expand': filterFieldValue.key === 'expand' }"
      @close="
        () => {
          $emit('tagClosed', { name: filter.name, item: filterFieldValue });
        }
      "
      @click="handleShowAll(filterFieldValue)"
    >
      <span v-if="filter.type === 'dateDay' || filter.type === 'dateString'">
        {{ filterFieldValue.label | date('DD/MM/yyyy') }}
      </span>
      <span v-else>
        {{ filterFieldValue.label }}
      </span>
    </el-tag>
  </div>
</template>

<script>
  export default {
    name: 'FilterTags',
    props: {
      filter: { type: Object, default: () => {} },
      filterData: { type: Array, default: () => [] },
    },
    data() {
      return {
        showAll: false,
      };
    },
    computed: {
      shrinkedFilters() {
        if (this.filterData.length > 5 && !this.showAll) {
          const shrinkedFilters = this.filterData.slice(0, 4);
          return [...shrinkedFilters, { key: 'expand', label: '...' }];
        }
        return this.filterData;
      },
    },
    methods: {
      handleShowAll(filter) {
        if (filter.key === 'expand') this.showAll = true;
      },
    },
  };
</script>

<style lang="scss">
  .tag-container {
    min-height: 30px;

    .filter-tag {
      margin: 0 4px 4px 0;
      word-break: break-all;
      white-space: normal;
      height: auto;
    }

    .filter-expand {
      cursor: pointer;
    }
  }
</style>
